import { _ } from '../model/ccc'
import type { IData } from '../model/IData'
import type { IPerson } from '../model/IPerson'
import { formatDate } from './formatDate'
import { getBirthDateFallback } from './getBirthDateFallback'
import { getDeathDateFallback } from './getDeathDateFallback'
import { hasBirthday } from './hasBirthday'

export function getLifeDateFormatted({
	data,
	isDeath,
	person,
	isYearOnly,
	defaultFuture,
}: {
	data: IData
	isDeath?: boolean
	isYearOnly?: boolean
	person: IPerson
	defaultFuture?: string
}) {
	const date = isDeath
		? getDeathDateFallback(data, person)
		: getBirthDateFallback(data, person)
	const result = formatDate(
		isYearOnly || date.isFallback ? date.value?.slice(0, 4) : date.value,
	)
	if (result) {
		if (date.isFallback) {
			return (
				<span class={_.ccc_unknown} title={date.fallbackSource}>
					({result.slice(0, -1)}?)
				</span>
			)
		} else {
			return result + (!isDeath && hasBirthday(person) ? '🎂' : '')
		}
	} else if (isDeath && !date.isFallback) {
		return defaultFuture ?? ''
	} else {
		return <span class={_.ccc_unknown}>?</span>
	}
}
